<template>
  <CContainer fluid>
    <h3 class="text-muted ">N&oacute;mina Electr&oacute;nica</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6" sm="6">
            <CInput 
              label="Buscar:" 
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="sm-6" sm="6">
            <CButton 
              color="info" 
              variant="outline" 
              class="mt-4" @click="showPanelImportFile = true">
              <i class="bi bi-cloud-upload h4 mr-2"></i>
              <span>Importar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable 
          hover 
          :fields="colunms" 
          :items="campaigns" 
          :items-per-page="itemsPerPage">
          <template #informacion="{item}">
            <td>
              <div>
                <h3>{{ item.prefijo }} {{ item.numero }}</h3>
              </div>
            </td>
          </template>
          <template #empleado="{item}">
            <td>
              <div>
                <h4>{{ item.empleado }}</h4>
              </div>
              <div>
                <i class="bi bi-postcard mr-2"></i>
                <span>{{ item.identificacion }}</span>
              </div>
              <div>
                <CLink 
                  @click="(e) => {
                    e.stopPropagation();
                  }" 
                  :href="`https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${item.cune}`" target="_blank">
                  <small>{{ item.cune }}</small>
                </CLink>
              </div>
            </td>
          </template>
          <template #periodos="{item}">
            <td>
              <div>
                <h4>{{ moment(item.periodo).format("MM/YYYY") }}</h4>
              </div>
              <div>
                <i class="bi bi-calendar3 mr-2"></i>
                <span>{{ moment(item.fecha_Creacion).format('DD/MM/YYYY') }}</span>
              </div>
              <div>
                <i class="bi bi-clock mr-2"></i>
                <span>{{ moment(item.fecha_Creacion).format("hh:mm:ss") }}</span>
              </div>
            </td>
          </template>
          <template #acciones="{item}">
            <td>
              <div>
                <span>{{ item.temp }}</span>
              </div>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <div class="d-flex mx-4 d-flex justify-content-end">
                <a href="#" 
                  class="mr-2" 
                  @click="goTo('editar', item.id_Campania)">
                  <CIcon name="cil-pencil" size="lg" class="text-warning"></CIcon>
                </a>
                <a href="#" 
                  class="mr-2" 
                  @click="(e) => tryDelete(e, item.id_Campania)">
                  <CIcon name="cil-trash" size="lg" class="text-danger"></CIcon>
                </a>
                <a href="#" 
                  class="mr-2"
                  @click="() => $router.push({ path: `${rootPath}/productoscampanias` })">
                  <CIcon name="cil-barcode" size="lg" class="text-dark"></CIcon>
                </a>
              </div>
              <CRow>
                <div class="ml-4"><strong>Descripción: </strong></div>
                <p class="mx-4">
                  {{ item.descripcion }}
                </p>
              </CRow>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination 
          size="sm" 
          class="d-flex justify-content-center" 
          :activePage.sync="page" 
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)" />
        </CCardBody>

        <LoadingCover v-show="loading" />
    </CCard>

    <!-- Panel sidebar para importacion de archivo excel -->
    <RightSideBar size="md" class="bg-s3grey" :show="showPanelImportFile">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              <h4>Importacion archivo de Novedades</h4>
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="import_fields" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="info" 
                class="mr-2"
                @click="(e) => importFile(e)">
                <CIcon name="cil-check-circle" />
                <span class="align-middle ml-2">Guardar</span>
              </CButton>
              <CButton 
                color="secondary"
                variant="outline"
                @click="(e) => {
                  e.stopPropagation();
                  e.preventDefault();

                  showPanelImportFile = null;
                }">
                <CIcon name="cil-x-circle" />
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

  </CContainer>
</template>
<script>
  import moment from "moment";
  import CONSTANTS from "@/constants";
  import { 
    errorMessage, 
    toBase64 
  } from "@/general";
  import { 
    dataGridNominasElectronicas, 
    importFileElectronicPayroll 
  } from "@/apis/payroll";

  import RightSideBar from "@/components/containers/RightSideBar.vue";
  import VerticalDynamicForm from "@/components/containers/VerticalDynamicForm.vue";
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  const colunms = [
    { 
      key: "informacion", 
      label: "Informacion", 
      _style:'text-align:center;'
    },
    { 
      key: "empleado", 
      label: "Empleado", 
      _style:'text-align:center;'
    },
    { 
      key: "periodos", 
      label: "Periodos", 
      _style:'text-align:center;'
    },
    { 
      key: "acciones", 
      label: ""
    }
  ]

  export default {
    data() {
      return {
        import_fields: [
          {
            key: "period",
            label: "Periodo:",
            value: "",
            type: "text",
            placeholder: "AAAAMM",
            required: true,
            prepend_content: {
              name: "calendar-date"
            }
          },
          {
            key: "fileExcel",
            label: "Archivo Excel:",
            value: "",
            type: "file",
            required: true
          }
        ],
        rootPath: "",
        loading: false,
        showPanelImportFile: null,
        isValidForm: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        colunms,
        campaigns: [],
        campaignStatus: {
          'A': 'Activa',
          'P': 'Pausada',
          'F': 'Finalizada'
        },
        idCompaingSelected: ""
      }
    },
    components: {
      RightSideBar,
      VerticalDynamicForm,
      LoadingCover
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true
        this.searchWord = search

        try {
          const { count, results } = await dataGridNominasElectronicas(this, page, search)
          
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }
          this.campaigns = results
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: errorMessage(error),
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async importFile(e) {
        e.stopPropagation();
        e.preventDefault();

        this.loading = true;

        try {
          const fileBase64 = await toBase64(this.import_fields[1].value).then(file => file);
          const parametros = {
            "Periodo": this.import_fields[0].value,
            "Archivo_Base64": fileBase64
          }

          await importFileElectronicPayroll(this, parametros);

          this.import_fields[0].value = "";
          this.import_fields[1].value = ""

          this.$store.commit("setAlert", {
            color: "success",
            message: "El archivo se cargo correctamente y se esta procesando. Cuando se termine el proceso se le notificara.",
            show: 5
          });
        }  catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Ocurrio un error al importar y/o procesar el archivo. Error: ${error}`,
            show: 5
          });
        } finally {
          this.loading = false;
          this.showPanelImportFile = null;
        }
      },
      tryDelete(e, idCampaign) {
        e.stopPropagation();
        e.preventDefault();

        this.idCompaingSelected = idCampaign;

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar";
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red";

        this.$confirm("¿Confirma que desea borrar la campaña?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteCampaign();
        }).catch(() => {
            this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert);
        });
      },
      toggleDocument(e, item) {
        e.preventDefault();
        e.stopPropagation();

        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      }
    },
    setup() {

    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;

      this.getData();
    }
  }
</script>
